<template>
  <div class="tw-w-full">
    <template v-if="initial_pagination_finished">
      <course-hero v-if="highlighted_course" :author="highlighted_course.author" :course="highlighted_course"
                   :extended="false" :lessons="highlighted_course.lessons"
                   :modules="highlighted_course.modules" :uploads="highlighted_course.uploads"></course-hero>
    </template>

    <div class="flex-parent-center membership-courses-overview">
      <div class="flex-1 flex-full-width tw-px-0">
        <courses-cards-v4 :courses="orderedCourses"
                       :currently_paginating="currently_paginating"
                       :loaded="initial_pagination_finished && highlighted_course_loaded"></courses-cards-v4>
      </div>
    </div>
  </div>
</template>

<script>
import SimplePagination from '../../mixins/SimplePagination.js';
import CourseHero from '../../components/e-learning/CourseHero.vue';
import CoursesCardsV4 from '../../components/e-learning/CoursesCardsV4.vue';

export default {
  name: 'CoursesIndex',

  mixins: [SimplePagination],

  components: {
    CourseHero,
    'courses-cards-v4': CoursesCardsV4,
  },

    data() {
        return {
            highlighted_course_loaded: false,
            highlighted_course: false,
            pagination_settings: {
                paginate_until_scrollable: true,
                minimum_pagination_items: 10,
            },
        }
    },

  computed: {
    orderedCourses() {
      return CourseV4.query().orderBy('index', 'asc').get();
    },

    paginationItemsLength() {
      return this.orderedCourses.length;
    },
  },

  methods: {
    paginate() {
      let request = {};

      let params = new URLSearchParams();

      params.append('page', this.pagination.current_page ? this.pagination.current_page += 1 : 1);
      params.append('category', '');

      request.params = params;

      return new Promise((resolve) => {
        CourseV4.api().fetch(params).then((response) => {
          resolve(response.response);
        });
      });
    },

    fetchHighlighted() {
      CourseV2.api().fetchHighlighted().then((response) => {
        if (response.response.data !== '') {
          this.highlighted_course = response.response.data.data[0];
        }

        this.highlighted_course_loaded = true;
      }).catch(() => {
        this.highlighted_course_loaded = true;
      });
    },
  },

  mounted() {
    this.fetchHighlighted();

    const metaTitle = this.$settings('meta_title') !== '' ? this.$settings('meta_title') + ' | ' : '';

    document.title = metaTitle + this.$t('membership.products');
  }
};
</script>

<style lang="scss" scoped>
.membership-courses-overview {
  max-width: 1170px;
  padding-left: 15px;
  padding-right: 15px;
}
</style>
